import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import RoleSelect from "@/pages/RoleSelect";
import CaseList from "@/pages/CaseList";
import NewCase from "@/pages/NewCase";
import CaseWorkspace from "@/pages/CaseWorkspace";
import SummaryPage from "@/pages/SummaryPage";
import JourneyPage from "@/pages/JourneyPage";
import PublicSummary from "@/pages/PublicSummary";
import DoctorFindings from "@/pages/DoctorFindings";
import Disclaimer from "@/components/Disclaimer";
import { useLocation } from "react-router-dom";

function DisclaimerGate() {
  const { pathname } = useLocation();
  if (pathname.endsWith("/summary")) return null;
  return <Disclaimer />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RoleSelect />} />
          <Route path="/:role/cases" element={<CaseList />} />
          <Route path="/:role/cases/new" element={<NewCase />} />
          <Route path="/:role/cases/:caseId" element={<CaseWorkspace />} />
          <Route path="/:role/cases/:caseId/summary" element={<SummaryPage />} />
          <Route path="/:role/cases/:caseId/journey" element={<JourneyPage />} />
          <Route path="/:role/cases/:caseId/findings" element={<DoctorFindings />} />
          <Route path="/share/:caseId" element={<PublicSummary />} />
        </Routes>
        <DisclaimerGate />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
